export default "__VITE_PUBLIC_ASSET__1ac8abd7__"